import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  IconButton,
  Input,
  InputAdornment,
  Grid,
  Button
} from "@mui/material";
import CountryAsynchronous from "../Settings/Autocomplete/CountryAsynchronous";

import {
  getLgaByStateId,
  getStatesByCountryId,
  getWaecApprovedSchools,
} from "../../redux/settings/settingsActions";
import StateAsynchronous from "../Settings/Autocomplete/StateAsynchronous";
import LgaAsynchronous from "../Settings/Autocomplete/LgaAsynchronous";
import SchoolAsynchronous from "../Settings/Autocomplete/SchoolAsynchronous";
import { alpha, styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { useDispatch, useSelector } from "react-redux";
import { getUserCategory } from "../../redux/auth/authActions";
import Axios from "../../connection/defaultClient";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import useUser from "../../hooks/useUser";
import useSubscription from "../../hooks/useSubscription";
import { fetchSubPlans } from "../../redux/subscriptions";
import { PlusIcon } from "../../assets/icons/Icons";
import { useNotifications } from "../notifications/notifications";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#A0AAB4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E0E3E7",
    },
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#6F7E8C",
    },
  },
});


const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 8,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#b4b4b4" : "#2D3843",
    fontSize: 16,
    // width: 'auto',
    // marginBottom: "20px",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      //   boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      //   borderColor: theme.palette.primary.main,
    },
    cursor: "auto",
  },
}));



const SponsorOfflinePayment = ({ level, closeModal, setToastState, countryHandler, updateValue, values, setValues, updateStateValue,
  stateHandler,
  lgaHandler,
  updateLgaValue,
schoolHandler,
 stateValues,
 lgaValues,
  updateSchoolValue,
   schoolValues,
   handleChangeCountry}) => {
  const dispatch = useDispatch();
  const user = useUser();
  const { userCategory, isLoading, userInfo, countries, statesByCountryId, } = user;
  const subscription = useSubscription();
  const { allSubPlan, loading } = subscription;
  const [selectedSponsor, setSelectedSponsor] = useState("");
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(0);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedCatOrder, setSelectedCatOrder] = useState(null)
  const [numberOfLicense, setNumberOfLicense] = useState(1);
  const [selectedSubscriptionAmount, setSelectedSubscriptionAmount] = useState(0);

  const initialFormValues = {
    firstName: "",
    lastName: "",
    surName: "",
    super: "Super",
    school: "School",
    schoolName: "",
    schoolAddress: "",
    countryId: 0,
    stateId: 0,
  };




  const [formValues, setFormValues] = useState({ ...initialFormValues });





  // useEffect(() => {
  //   dispatch(getUserCategory());
  //   dispatch(fetchSubPlans(selectedUserType));
  // }, [selectedUserType]);

  // const handleIncrement = () => {
  //   setNumberOfLicense((prevCount) => prevCount + 1);
  // };

  // const handleDecrement = () => {
  //   if (numberOfLicense > 1) {
  //     setNumberOfLicense((prevCount) => prevCount - 1);
  //   }
  // }


  //   const onSuccess = (res) => {
  //     closeModal(true);
  //     if (sponsorId) {
  //       dispatch(fetchGetStudentBySponsorId(sponsorId));
  //     }
  //     setToastState({
  //       isOpen: true,
  //       severity: "success",
  //       message: res.msg,
  //     });
  //     setTimeout(() => {}, 1000);
  //   };

  //   const onFail = (res) => {
  //     setToastState({
  //       isOpen: true,
  //       severity: "error",
  //       message: res.msg,
  //     });
  //     setTimeout(() => {
  //       // navigate('/dashboard/home')
  //     }, 3000);
  //     closeModal(true);
  //     // window.location.reload();
  //   };

  //   useEffect(() => {
  //     dispatch(fetchSponsorSubscriptions(sponsorId));
  //   }, []);

  //   const onSelectChange = async (event) => {
  //     const selectedValue = event.target.value;
  //     setSelectedSponsor(selectedValue);
  //     const sponsorId = selectedValue;

  //     dispatch(fetchSchoolSubscriptionsBySponsorId(schoolId, sponsorId));
  //   };

  //funciton to add student by school and sponsor
  //   const handleAddSingleStudent = () => {
  //     setIsLoading(true);
  //     const payload = {
  //       firstName: formValues.firstName,
  //       surname: formValues.surName,
  //       email: formValues.emailAddress,
  //       gender: formValues.gender,
  //       phoneNumber: formValues.phoneNumber,
  //       isVerified: false,
  //     };
  //     if (userInfo?.schoolId !== null) {
  //       dispatch(
  //         fetchAddStudent(
  //           userInfo?.schoolId,
  //           selectedSponsor,
  //           selectedSubscriptionId,
  //           payload,
  //           onSuccess,
  //           onFail
  //         )
  //       );
  //       dispatch(fetchGetStudent(schoolId));
  //     } else {
  //       dispatch(
  //         fetchAddStudent(
  //           userInfo?.schoolId,
  //           userInfo?.sponsorId,
  //           selectedSubscriptionId,
  //           payload,
  //           onSuccess,
  //           onFail
  //         )
  //       );
  //       dispatch(fetchGetStudentBySponsorId(sponsorId));
  //     }
  //   };

  //   const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     setFormValues((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   };

  //   const handleRadioChange = (event) => {
  //     setSelectedSubscriptionOption(event.target.value);
  //     dispatch(fetchGetSchoolSponsorsBySchoolId(userInfo?.schoolId));
  //   };


  // const stateByCountryFailure = (res) => {
  //   if (res !== 1) {
  //     setToast({
  //       isOpen: true,
  //       message: "An error occured!",
  //       severity: "error",
  //     });
  //   }
  // };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   // setInput({ ...input, schoolName: value });
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: value,
  //   }));
  // };
  // const handleChanges = (event) => {
  //   const { name, value } = event.target;
  //   // setInput({ ...input, schoolAddress: value });
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: value,
  //   }));
  // };

  // //functionality for country
  // const countryHandler = (event, val) => {
  //   if (event) {
  //     setStateValues({ label: "", value: 0 });
  //     // setInput({ ...input, countryId: val.value });
  //     setFormValues({
  //       ...formValues,
  //       countryId: val.value,
  //     });

  //     dispatch(getStatesByCountryId(val?.value, stateByCountryFailure));
  //   }
  // };

  // const updateValue = (value) => {
  //   setFormValues({
  //     ...formValues,
  //     countryId: value.value,
  //   });
  //   // setInput({ ...input, countryId: value.value });
  //   setValues({
  //     ...values,
  //     label: value.label,
  //     value: value.value,
  //   });
  // };
  // const stateHandler = (event, val) => {
  //   if (event) {
  //     setLgaValues({ label: "", value: 0 });
  //     setFormValues({
  //       ...formValues,
  //       stateId: val.value,
  //     });

  //     dispatch(getLgaByStateId(val?.value, lgaByStateFailure));
  //   }
  // };

  // const updateStateValue = (value) => {
  //   setFormValues({
  //     ...formValues,
  //     stateId: value.value,
  //   });
  //   // setInput({ ...input, stateId: value.value });
  //   setStateValues({
  //     ...values,
  //     label: value.label,
  //     value: value.value,
  //   });
  // };

  // const lgaHandler = (event, val) => {
  //   if (event) {
  //     setSchoolValues({ label: "", value: 0 });
  //     setFormValues({
  //       ...formValues,
  //       lgaId: val.value,
  //     });

  //     dispatch(
  //       getWaecApprovedSchools(
  //         formValues?.countryId,
  //         formValues?.stateId,
  //         val?.value,
  //         schoolFailure
  //       )
  //     );
  //   }
  // };

  // const updateLgaValue = (value) => {
  //   setFormValues({
  //     ...formValues,
  //     lgaId: value.value,
  //   });
  //   // setInput({ ...input, lgaId: value.value });
  //   setLgaValues({
  //     ...values,
  //     label: value.label,
  //     value: value.value,
  //   });
  // };

  // const schoolHandler = (event, val) => {
  //   if (event) {
  //     setFormValues({
  //       ...formValues,
  //       schoolId: val.value,
  //     });
  //   }
  // };

  // const updateSchoolValue = (value) => {
  //   setFormValues({
  //     ...formValues,
  //     WAECSchoolID: value.value,
  //   });
  //   // setInput({ ...input, WAECSchoolID: value.value });
  //   setSchoolValues({
  //     ...values,
  //     label: value.label,
  //     value: value.value,
  //   });
  // };

  // const lgaByStateFailure = (res) => {
  //   if (res !== 1) {
  //     setToast({
  //       isOpen: true,
  //       message: "An error occured!",
  //       severity: "error",
  //     });
  //   }
  // };

  // const schoolFailure = (res) => {
  //   if (res !== 1) {
  //     setToast({
  //       isOpen: true,
  //       message: "An error occured!",
  //       severity: "error",
  //     });
  //   }
  // };




  // const handleChangeCountry = (event) => {
  //   const value = event.target.value;
  //   // setInput({ ...input, countryId: value });
  //   dispatch(getStatesByCountryId(value));
  // };



  // const handleSelectedUserChange = (event) => {
  //   const typeid = event.target.value;
  //   setSelectedUserType(typeid);
  //   const category = userCategory?.find((cat) => cat.CategoryID === typeid)?.CategoryOrder;
  //   setSelectedCatOrder(category);
  // };
  // const handleSubscriptionChange = (event) => {
  //   debugger
  //   const subId = event.target.value;
  //   setSelectedSubscriptionId(subId);
  //   const subscriptionAmount = allSubPlan?.data?.find((sub) => sub.PackageOrder === subId)?.Amount;
  //   setSelectedSubscriptionAmount(subscriptionAmount);
  // };

  const subAmount = selectedSubscriptionAmount;

  const subtotal = parseInt(subAmount) * numberOfLicense;

  return (
    <>
      <div className="bg-white rounded-2xl ">


        <div className="grid grid-cols-2 gap-3 px-12 mb-8 justify-between">
          <div >
            <FormControl fullWidth>
              <CountryAsynchronous
                updateValue={updateValue}
                countryHandler={countryHandler}
                BootstrapInput={BootstrapInput}
                values={values}
              // values={input.value}
              />
            </FormControl>
          </div>

          <div>

            <FormControl fullWidth>
              <StateAsynchronous
                updateStateValue={updateStateValue}
                stateHandler={stateHandler}
                stateValues={stateValues}
              />
            </FormControl>
          </div>
         


        </div>
        <div className= "flex flex-col gap-[24px] px-12 mb-8">
        <FormControl fullWidth>
                <LgaAsynchronous
                  updateLgaValue={updateLgaValue}
                  lgaHandler={lgaHandler}
                  lgaValues={lgaValues}
                />
              </FormControl>
        </div>
        <div className= "flex flex-col gap-[24px] px-12 mb-8">
        <FormControl fullWidth>
                <SchoolAsynchronous
                  updateSchoolValue={updateSchoolValue}
                  schoolHandler={schoolHandler}
                  schoolValues={schoolValues}
                  schOnboardedOptions={true}
                />
              </FormControl>
        </div>
        
       


        {/* </Box> */}
        {/* ) : !sponsorSchool ? (
          <Box pb={3}>
            <FormControl variant="standard" fullWidth>
              <InputLabel
                htmlFor="bootstrap-input"
                sx={{ fontWeight: 800, fontSize: "18px", color: "#313131" }}
              >
                How many students do you want to sponsor?
              </InputLabel>
              <Input
                id="bootstrap-input"
                type="number"
                value={studentsCount}
                onChange={(e) => setStudentsCount(e.target.valueAsNumber || 0)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="add" onClick={handleDecrement}>
                      <RemoveIcon />
                    </IconButton>
                    <IconButton aria-label="add" onClick={handleIncrement}>
                      <AddIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
        ) : <Box pb={3}>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={3}
            pb={3}
          >
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <FormControl fullWidth>
                <CountryAsynchronous
                  updateValue={updateValue}
                  countryHandler={countryHandler}
                  BootstrapInput={BootstrapInput}
                  values={values}
                
                />
              </FormControl>

            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <FormControl fullWidth>
                <StateAsynchronous
                  updateStateValue={updateStateValue}
                  stateHandler={stateHandler}
                  stateValues={stateValues}
                />
              </FormControl>
            </Grid>

          </Grid>

          <Grid item xs={12} pb={4}>
            <FormControl fullWidth>
              <TextField
                label="School Name"
                id="outlined-basic"
                placeholder="E.g HoneyLand International Schools"
                variant="outlined"
                name="schoolName"
                value={input.schoolName}
                onChange={handleChanges}
              />
            </FormControl>
          </Grid>


          <Grid item xs={12} pb={4}>
            <FormControl fullWidth>
              <TextField
                label="School Address"
                id="outlined-basic"
                placeholder="E.g Street or Block"
                variant="outlined"
                name="schoolAddress"
                value={input.schoolAddress}
                onChange={handleChanges}
              />
            </FormControl>
          </Grid>

          <FormControl variant="standard" fullWidth>
            <InputLabel
              htmlFor="bootstrap-input"
              sx={{ fontWeight: 800, fontSize: "18px", color: "#313131" }}
            >
              How many students do you want to sponsor?
            </InputLabel>
            <Input
              id="bootstrap-input"
              type="number"
              value={studentsCount}
              onChange={(e) => setStudentsCount(e.target.valueAsNumber || 0)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label="add" onClick={handleDecrement}>
                    <RemoveIcon />
                  </IconButton>
                  <IconButton aria-label="add" onClick={handleIncrement}>
                    <AddIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>


        </Box>
        } */}

        {/* 
        <div className="flex flex-col gap-[24px] px-12 mb-8">
          <select
            name="subscription"
            id="UserType"
            className="min-w-full h-[46px] bg-[#fff] rounded-[10px] font-normal text-[#3d3d3d] text-base px-4  border border-black"
            onChange={handleSubscriptionChange}
            value={selectedSubscriptionId}
          // disabled={isLoading}
          >
            <option value="">Subcription Plan*</option>
            {allSubPlan?.data?.map((plan, index) => (
              <option key={index}
                value={plan.PackageOrder}
              >
                {`${plan.PackageName}`}
              </option>
            ))
            }
          </select>
        </div>
        {selectedCatOrder !== 2 ? (
          <div className="flex flex-col gap-[18px] px-12 mb-8">
            <lable html="firstName" sx={{marginBottom:"10px"}}>First Name</lable>
            <TextField
              label="First Name"
              id="outlined-basic"
              variant="outlined"
              size="small"
              name="firstName"
              value={formValues.firstName}
              onChange={handleChange}
              disabled={isLoading}

              required

            />
              <lable html="lastName">Last Name</lable>
            <TextField
              label="Last Name"
              id="outlined-basic"
              variant="outlined"
              size="small"
              name="lastName"
              value={formValues.lastName}
              onChange={handleChange}
              disabled={isLoading}

              required

            />
          </div>
        ) : (<div className="flex flex-col gap-[24px] px-12 mb-8">
          <lable html="firstName">First Name</lable>
          <TextField
            label="Super"
            id="outlined-basic"
            variant="outlined"
            size="small"
            name="super"
            value={formValues.super}
            // onChange={handleChange}
            disabled={true}

            required

          />
          <lable html="lastName">Last Name</lable>
          <TextField
            id="outlined-basic"
            variant="outlined"
            label="School"
            size="small"
            name="school"
            value={formValues.school}
            // onChange={handleChange}
            disabled={true}

            required

          />
        </div>)}
         <div className="flex flex-col gap-[24px] px-12 mb-8">
                 <select
            name="School"
            id="Schools"
            className="min-w-full h-[46px] bg-[#fff] rounded-[10px] font-normal text-[#3d3d3d] text-base px-4  border border-black"
            onChange={handleSelectedUserChange}
            value={selectedUserType}
            disabled={isLoading}
          >
            <option value="">User Type*</option>
            {userCategory?.map((type, index) => (
              <option key={index}
                value={type.CategoryID}
              >
                {`${type.CategoryName}`}
              </option>
            ))
            }
          </select>
        </div>
       
        <div className="flex flex-col gap-[24px] px-12 mb-8">
        <FormControl variant="standard" fullWidth>
          <InputLabel
            htmlFor="bootstrap-input"
            sx={{ fontWeight: 800, fontSize: "18px", color: "#313131" }}
          >
            Number of enrollment?
          </InputLabel>
          <Input
            id="bootstrap-input"
            type="number"
            value={numberOfLicense}
            onChange={(e) => setNumberOfLicense(e.target.valueAsNumber || 0)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="add" onClick={handleDecrement}>
                  <RemoveIcon />
                </IconButton>
                <IconButton aria-label="add" onClick={handleIncrement}>
                  <AddIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        </div> */}
        {/* <div className="flex flex-col gap-[24px] px-12 mb-8 space-between">
<div>
Total 
</div>
<div>
{subtotal}
</div>
        </div> */}

      </div>
    </>
  );
};

export default SponsorOfflinePayment;
